import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { IXactimateToolRowData } from "../../../../../shared/common/Azure";
import { XactimateBadge } from "./shared";
import { MappingCardEditor } from "./MappingCardEditor";

interface VariantOverrideCardProps {
    perm: string;
    inheritedFrom: IXactimateToolRowData;
    onCreate: (mapping: IXactimateToolRowData) => Promise<void>;
}

export const VariantOverrideCard = ({ perm, inheritedFrom, onCreate }: VariantOverrideCardProps) => {
    const [isEditing, setIsEditing] = useState(false);

    // Pre-fill the editor with the representative's xactimate values, but scope
    // the new mapping to this specific permutation string so it overrides the
    // shared no-activity mapping for just this action variant.
    const draftMapping: IXactimateToolRowData = {
        ...inheritedFrom,
        id: uuidv4(),
        createdAt: Date.now(),
        acceptedLineString: perm,
        lineNoSpaces: perm.replace(/\s+/g, ""),
    };

    return (
        <div className="border rounded-lg p-3 bg-green-50/40 border-green-200 border-dashed ml-6">
            <p className="font-mono text-xs text-stone-700 mb-1">{perm}</p>
            {isEditing ? (
                <MappingCardEditor
                    mapping={draftMapping}
                    onSave={onCreate}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <div className="flex items-center gap-2 flex-wrap mt-1">
                    <XactimateBadge mapping={inheritedFrom} />
                    <span className="text-xs text-stone-400 italic">inherited</span>
                    <button
                        className="text-xs text-stone-500 hover:text-stone-700 underline ml-auto"
                        onClick={() => setIsEditing(true)}
                    >
                        Override
                    </button>
                </div>
            )}
        </div>
    );
};
